// MIMETYPE
export const MIME_JPEG = "image/jpeg"
export const MIME_JPG = "image/jpg"
export const MIME_PNG = "image/png"
export const MIME_GIF = "image/gif"
export const MIME_IMAGE = [MIME_JPEG, MIME_JPG, MIME_PNG, MIME_GIF]
export const MIME_PDF = "application/pdf"
export const MIME_CSV = "text/csv"
export const MIME_MS = "application/vnd.ms-excel"
export const MIME_SHEET = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
export const MIME_SPREADSHEET = [MIME_CSV, MIME_MS, MIME_SHEET]
export const MIME_MP4 = "video/mp4"
export const MIME_AVI = "video/avi"
export const MIME_WEBM = "video/webm"
export const MIME_QUICKTIME = "video/quicktime"
export const MIME_3GP = "video/3gpp"
export const MIME_VIDEO = [MIME_MP4, MIME_AVI, MIME_WEBM, MIME_QUICKTIME, MIME_3GP]
export const MIME_OCTETSTREAM = "application/octet-stream"
export const MIME_MP3 = "audio/mp3"
export const MIME_MPEG = "audio/mpeg"
export const MIME_MP4A = "audio/mp4"
export const MIME_WEBA = "audio/weba"
export const MIME_WAV = "audio/wav"
export const MIME_M4A = "audio/x-m4a"
export const MIME_AUDIO = [
  MIME_WEBA,
  MIME_MP4A,
  MIME_MP3,
  MIME_MPEG,
  MIME_WAV,
  MIME_M4A,
  MIME_OCTETSTREAM,
]
export const MIME_DEFAULT = "application/octet-stream"
